/**
 * Vincent B934 (Eric 2026-02-14 SPEC STRICK PROD) — Normalisation de
 * clef pour les noms de locuteurs.
 *
 * Cas résolu : sur la vidéo `ebcfd146-...` (Close lead levier), le
 * locuteur « Émilie Gaboury » apparaissait deux fois dans le tableau
 * du SpeakerLegendBox — une fois pour Whisper (en italique/barré) et
 * une fois pour Fireflies. Les deux variantes du nom (typiquement un
 * espace insécable, un accent NFC vs NFD, ou une majuscule différente)
 * n'étaient pas fusionnées par le simple `trim()` utilisé auparavant.
 *
 * Cette fonction produit une clef de comparaison stable :
 *   • forme NFD → retire les diacritiques (é → e)
 *   • lowercase
 *   • collapse tous les espaces (dont espaces insécables) en un seul
 *   • trim
 *
 * NE PAS l'utiliser pour l'affichage — c'est UNIQUEMENT une clef de
 * dédoublonnage. Le displayName original (première variante rencontrée)
 * doit être conservé et affiché tel quel à Vincent.
 *
 * Export en CommonJS + ES module (module.exports + exports.X) pour
 * rester testable via un simple require() côté Jest sans babel-jest
 * supplémentaire. Cohérent avec `lib/speakerDivergence.js` (B922).
 */
function normalizeSpeakerKey(name) {
  return String(name || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .toLowerCase()
    // \s couvre les espaces standards, tab, retour ligne. On ajoute
    // \u00a0 (NBSP) explicitement au cas où l'engine JS n'y matcherait pas.
    .replace(/[\s\u00a0]+/g, " ")
    .trim();
}

/**
 * Compare deux noms de locuteur pour savoir s'ils désignent la même
 * personne (normalisation NFD + lowercase + whitespace).
 * Retourne `false` si l'une des deux chaînes est vide après
 * normalisation — évite les faux positifs sur segments sans speaker.
 */
function isSameSpeakerName(a, b) {
  const na = normalizeSpeakerKey(a);
  const nb = normalizeSpeakerKey(b);
  return !!na && na === nb;
}

module.exports = { normalizeSpeakerKey, isSameSpeakerName };
module.exports.normalizeSpeakerKey = normalizeSpeakerKey;
module.exports.isSameSpeakerName = isSameSpeakerName;
